/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        BotMain: 'BotMain',// '승인잔액 조회를 도와드리겠습니다.<br>아래에 정보를 입력해주세요.',
        CardComment: 'CardComment',// '카드번호 앞, 뒤 4자리를 입력하세요.',
        Number: 'Number',// '승인번호',
        CheckRemain: 'CheckRemain', // 승인잔액 조회하기',
        BotResult: 'BotResult',// '승인잔액 조회결과를 보여드리겠습니다.',
        RemainResult: 'RemainResult',// '승인잔액 조회결과',
        InputCardNumAppNum: 'InputCardNumAppNum',// '카드번호와 승인번호를 입력하세요.',
        InputCardNum: 'InputCardNum',// '카드번호를 입력하세요.',
        InputAppNum: 'InputAppNum',// '승인번호를 입력하세요.',
        NotFound: 'NotFound',// '일치하는 정보가 없습니다.<br>카드번호와 승인버호를 확인해주세요.',
        BotComment: 'BotComment',// '승인일과 승인금액 입력이 추가로 필요합니다.',
        SelectDate: 'SelectDate',// '승인일자 선택하기',
        ViewRemain: 'ViewRemain',// '승인잔액 조회하기',
        Date: 'Date',// '승인일',
        Amount: 'Amount', // '승인금액',
        InputDate: 'InputDate',
        InputDateAmount: 'InputDateAmount',// '승인일과 승인금액을 입력하세요.',
        InputAmount: 'InputAmount',// '승인금액을 입력하세요.',
        NotFoundData: 'NotFoundData',// '일치하는 데이터가 없습니다.',
        BotShowResult: 'BotShowResult',// '승인잔액 조회결과를 보여드리겠습니다.',
    },
    tomy:{
        kr: {
            BotMain: '카드정보와 승인정보를 입력하면 승인잔액이 얼마나 남았는지 확인하실 수 있습니다.',
            CardComment: '카드번호 앞, 뒤 4자리를 입력하세요.',
            Number: '승인번호',
            CheckRemain: '승인잔액 조회하기',
            BotResult: '승인잔액 조회결과를 보여드리겠습니다.',
            RemainResult: '승인잔액 조회결과',
            InputCardNumAppNum: '카드번호와 승인번호를 입력하세요.',
            InputCardNum: '카드번호를 입력하세요.',
            InputAppNum: '승인번호를 입력하세요.',
            NotFound: '일치하는 정보가 없습니다. 카드번호와 승인번호를 확인하세요.',
            BotComment: '승인일과 승인금액 입력이 추가로 필요합니다.',
            SelectDate: '승인일자 선택하기',
            ViewRemain: '승인잔액 조회하기',
            Date: '승인일',
            Amount: '승인금액',
            InputDateAmount: '승인일과 승인금액을 입력하세요.',
            InputDate: '승인일자를 입력하세요.',
            InputAmount: '승인금액을 입력하세요.',
            NotFoundData: '일치하는 정보가 없습니다.',
            BotShowResult: '승인잔액 조회 결과를 보여드리겠습니다.',
        },
        eng: {
            BotMain: 'Enter information of your card and authorization to check how much of your approval balance is remaining.',
            CardComment: 'Enter first and last 4 digits of the card number.',
            Number: 'Authorization number',
            CheckRemain: 'View approved balance.',
            BotResult: 'We will show you the results of the approval balance inquiry.',
            RemainResult: 'Approved balance inquiry result',
            InputCardNumAppNum: 'Enter your card number and authorization number.',
            InputCardNum: 'Please enter your card number.',
            InputAppNum: 'Enter the authorization number.',
            NotFound: 'There is no matching information. Check your card number and authorization number.',
            BotComment: 'The approval date and approval amount inputs are additionally required.',
            SelectDate: 'Choose an approval date',
            ViewRemain: 'Checking Approval Balance',
            Date: 'Approval date',
            Amount: 'Approval amount',
            InputDate: 'Enter the approval date',
            InputDateAmount: 'Enter the approval date and approval amount.',
            InputAmount: 'Enter the approved balance.',
            NotFoundData: 'No matching information.',
            BotShowResult: 'We will show you the results of the approved balance inquiry.',
        }
    },
    papa:{
        kr: {
            BotMain: '그럼요, 얼마든지요. 승인잔액 조회에 필요한 카드정보랑 승인번호를 입력해주세요.',
            CardComment: '카드번호 앞, 뒤 4자리를 입력하세요.',
            Number: '승인번호',
            CheckRemain: '승인잔액 조회하기',
            BotResult: '승인잔액 조회결과를 보여드리겠습니다.',
            RemainResult: '승인잔액 조회결과',
            InputCardNumAppNum: '카드번호와 승인번호를 입력하세요.',
            InputCardNum: '카드번호를 입력하세요.',
            InputAppNum: '승인번호를 입력하세요.',
            NotFound: '일치하는 정보가 없습니다. 카드번호와 승인번호를 확인하세요.',
            BotComment: '승인일과 승인금액까지 입력하면 승인잔액을 조회할 수 있어요.',
            SelectDate: '승인일자 선택하기',
            ViewRemain: '승인잔액 조회하기',
            Date: '승인일',
            InputDate: '승인일자를 입력하세요.',
            Amount: '승인금액',
            InputDateAmount: '승인일과 승인금액을 입력하세요.',
            InputAmount: '승인금액을 입력하세요.',
            NotFoundData: '일치하는 정보가 없습니다. ',
            BotShowResult: '승인잔액이 얼마나 남았는지 확인해볼까요?',
        },
        eng: {
            BotMain: "All right, that's it! Please enter your card information and authorization number as required to check the approval balance.",
            CardComment: 'Enter first and last 4 digits of the card number.',
            Number: 'Authorization number',
            CheckRemain: 'View approved balance.',
            BotResult: "Let's check how much approval balance is left.",
            RemainResult: 'Approved balance inquiry result',
            InputCardNumAppNum: 'Enter your card number and authorization number.',
            InputCardNum: 'Please enter your card number.',
            InputAppNum: 'Enter the authorization number.',
            NotFound: 'There is no matching information. Check your card number and authorization number.',
            BotComment: 'You can view the approved balance by entering the approval date and approved balance.',
            SelectDate: 'Choose an approval date',
            ViewRemain: 'Checking Approval Balance',
            InputDate: 'Enter the approval date',
            Date: 'Approval date',
            Amount: 'Approval amount',
            InputDateAmount: 'Enter the approval date and approval amount.',
            InputAmount: 'Enter the approved balance.',
            NotFoundData: 'No matching information.',
            BotShowResult: "Let's check how much approval balance is left.",
        }
    },
};
